import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "../../components/app-toast";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { APP_PATH } from "../../api/backendPath";
import { ACTIONS_VERIFY_CLAIM } from "../../action-types/actions";

export const verifyClaim = createAsyncThunk(
  ACTIONS_VERIFY_CLAIM.verifyClaim,
  async (claimId, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();

    try {
      const response = await axiosPrivate.post(
        `${process.env.REACT_APP_API_URL}${APP_PATH.claims.replace(
          "{claimId}",
          claimId,
        )}/verify`,
      );

      if (response?.data?.status === true || response?.status === 200) {
        toast.success("Claim verified successfully");
        return response.data;
      } else {
        toast.error(response?.data?.message || "Failed to verify claim");
        return rejectWithValue(response.data);
      }
    } catch (error) {
      console.error("Error verifying claim:", error);
      const errMsg =
        error?.response?.data?.message ||
        "Something went wrong while verifying the claim";
      toast.error(errMsg);
      return rejectWithValue(errMsg);
    }
  },
);
